<script>var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { tick, createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();
export let text;
let textarea;
function copy() {
    return __awaiter(this, void 0, void 0, function* () {
        textarea.select();
        document.execCommand('Copy');
        yield tick();
        textarea.blur();
        dispatch('copy');
    });
}
</script>

<style>
    textarea {
        left: 0;
        bottom: 0;
        margin: 0;
        padding: 0;
        opacity: 0;
        width: 1px;
        height: 1px;
        border: none;
        display: block;
        position: absolute;
    }
</style>

<slot {copy} />
<textarea bind:this={textarea} value={text} />
